import React from 'react';
import { graphql, useFragment } from 'react-relay';
import { ProjectIcon } from '@atlassian/jira-horizontal-nav-icons/src/ui/icon/index.tsx';
import type { ProjectAvatar$key } from '@atlassian/jira-relay/src/__generated__/ProjectAvatar.graphql';
import { fg } from '@atlassian/jira-feature-gating';
import { NavigationKitAvatar } from './NavigationKitAvatar.tsx';
import { NavigationKitAvatarPopup } from './navigation-kit-avatar-popup/NavigationKitAvatarPopup.tsx';

const ProjectAvatar = ({ projectRef }: { projectRef: ProjectAvatar$key }) => {
	const data = useFragment<ProjectAvatar$key>(
		graphql`
			fragment ProjectAvatar on JiraProject {
				projectType
				projectId
				avatar {
					large
				}
				canEditProjectConfig: action(type: EDIT_PROJECT_CONFIG) {
					canPerform
				}
			}
		`,
		projectRef,
	);
	if (data?.projectType === 'BUSINESS') {
		return fg('jgfeng_fetch_system_avatars_on_demand') ? (
			<NavigationKitAvatarPopup
				canEdit={data?.canEditProjectConfig?.canPerform ?? false}
				projectId={Number(data?.projectId)}
				selectedAvatarUrl={data?.avatar?.large ?? ''}
			/>
		) : (
			<NavigationKitAvatar
				projectId={Number(data?.projectId)}
				selectedAvatarUrl={data?.avatar?.large ?? ''}
				canEdit={data?.canEditProjectConfig?.canPerform ?? false}
			/>
		);
	}
	if (!data.avatar) {
		return null;
	}
	return (
		<ProjectIcon
			src={`${data.avatar.large}?size=xlarge`}
			alt=""
			// eslint-disable-next-line jira/integration/test-id-by-folder-structure
			data-testid="horizontal-nav.ui.content.project-avatar"
			data-vc="jira-horizontal-nav-project-icon"
		/>
	);
};

export default ProjectAvatar;
